<template>
    <div class="swiper-container" role="region" :aria-label="$t('a11y.gallery')">
        <div ref="swiper" class="swiper swiper--xxl">
            <div class="swiper-wrapper">
                <div
                    v-for="(image, i) in images"
                    :key="`gallery-image-${i}`"
                    class="swiper-slide cursor-pointer"
                    @click="() => openLightbox(i)"
                >
                    <img
                        class="object-cover w-full h-full"
                        :src="image.src"
                        :alt="`${$t('generic.gallery_image_alt_text')} ${i}`"
                    />
                </div>
            </div>
            <SwiperNavigationButton
                v-if="images.length >= 2"
                :gallery-id="swiperId"
                prev
                overflow
                @click.native="prev"
            />
            <SwiperNavigationButton
                v-if="images.length >= 2"
                :gallery-id="swiperId"
                next
                overflow
                @click.native="next"
            />
        </div>

        <div
            v-if="images.length >= 2"
            class="carousel-pagination-block container relative mt-6 sm:mt-8 lg:mt-12 grid grid-cols-12 base-responsive-gap"
        >
            <nav
                :aria-label="$t('a11y.gallery_stepper')"
                class="col-span-12 xl:col-span-10 xl:col-start-2 2xl:col-span-12 2xl:col-start-1 flex items-center justify-center sm:justify-end"
            >
                <button ref="prevBtn" class="swiper-button-prev"></button>
                <span class="gallery-pagination-counter">01</span>
                <div ref="pagination" class="swiper-pagination"></div>
                <span class="gallery-pagination-counter">{{ String(images.length).padStart(2, '0') }}</span>
                <button ref="nextBtn" class="swiper-button-next"></button>
            </nav>
        </div>
    </div>
</template>

<script>
import SwiperNavigationButton from '@/components/UI/SwiperNavigationButton.vue';

export default {
    name: 'XXLGalleryCarousel',
    components: {
        SwiperNavigationButton,
    },
    props: {
        images: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            swiperId: null,
        };
    },
    mounted() {
        this.carousel = new this.$swiper(this.$refs.swiper, {
            spaceBetween: 16,
            slidesPerView: 1.2,
            centeredSlides: true,
            loop: this.images.length >= 2,
            navigation: {
                nextEl: this.$refs.nextBtn,
                prevEl: this.$refs.prevBtn,
            },
            pagination: {
                el: this.$refs.pagination,
                clickable: true,
                bulletElement: 'button',
            },
            a11y: {
                containerMessage: this.$t('carousel.a11y.container_message_gallery'),
                paginationBulletMessage: this.$t('carousel.a11y.pagination_bullet_message'),
                firstSlideMessage: this.$t('carousel.a11y.first_slide_message'),
                lastSlideMessage: this.$t('carousel.a11y.last_slide_message'),
                nextSlideMessage: this.$t('carousel.a11y.next_slide_message'),
                prevSlideMessage: this.$t('carousel.a11y.prev_slide_message'),
            },
            breakpoints: {
                640: {
                    spaceBetween: 30,
                    slidesPerView: 1.35,
                },
                1920: {
                    spaceBetween: 30,
                    slidesPerView: 1.41,
                },
            },
            on: {
                afterInit: (e) => {
                    this.swiperId = e.wrapperEl.id;
                },
            },
        });
    },
    beforeDestroy() {
        this.carousel.destroy();
    },
    methods: {
        prev() {
            this.carousel.slidePrev();
        },
        next() {
            this.carousel.slideNext();
        },
        openLightbox(slideIndex) {
            this.$nuxt.$emit('open-lightbox', {
                index: slideIndex,
                items: this.images,
            });
        },
    },
};
</script>

<style>
.swiper.swiper--xxl .swiper-slide {
    @apply h-[300px] sm:h-[400px] lg:h-[500px] xl:h-[600px] 2xl:h-[700px] 3xl:h-[40vw] rounded-xl lg:rounded-[40px] overflow-hidden;
    @apply opacity-50 transition-opacity duration-[500ms];

    &.swiper-slide-active {
        opacity: 1;
    }
}

/*

.gallery-thumbnails .swiper-slide {
    @apply opacity-80;
}
#gallery {
    @apply mb-[30px];

    .swiper-slide {
        @apply aspect-w-16 aspect-h-9;

        img {
            @apply object-cover;
        }
    }
}

#gallery-thumbnails {
    .swiper-slide {
        img {
            @apply object-cover;
        }
    }
}

*/
</style>
